"use client";

import { useState } from "react";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import BlogArticles from "../BlogArticles/BlogArticles";
import BlogCategories from "../BlogCategories/BlogCategories";
import { BLOG_CATEGORY_ALL } from "../BlogCategories/BlogCategories.logic";

export default function BlogFeed(props: DefaultProps) {
  const [activeId, setActiveId] = useState<string>(BLOG_CATEGORY_ALL);

  return (
    <>
      <BlogCategories activeId={activeId} onSelect={setActiveId} />
      <BlogArticles params={props.params} activeId={activeId} />
    </>
  );
}
